<template>
    <info-text-editor
      textKey="pvp_rewards"
      title="PvP Rewards"
      viewPermission="PvpRewardsView"
      editPermission="PvpRewardsEdit"
    />
</template>

<script>
import InfoTextEditor from './InfoTextEditor.vue'

export default {
  name: 'PvpRewards',
  components: {
    InfoTextEditor
  }
}
</script>
